export enum CountryCode {
    ES = 'ES',
    DE = 'DE',
    FR = 'FR',
    PT = 'PT',
    IT = 'IT',
    FI = 'FI',
    GR = 'GR',
    PL = 'PL',
    RO = 'RO',
    HR = 'HR',
}

export const countryCodeOptionValues = () => {
    return Object.values(CountryCode);
};

export const defaultCountryCode = CountryCode.ES;

export const countryCodeValueToEnum = (value: string) => {
    return CountryCode[value as keyof typeof CountryCode];
};
